export default __webpack_public_path__ + "static/media/ActiveProjects.5d917050.svg";